import { Box, Paper, Typography } from "@mui/material";
import { formatMoneyTotal } from "@/shared/utils/gridToPdfTable";

interface Props {
	/** The money total the PDF prints under its column. */
	money?: { label: string; value: number };
	total: number;
}

export const FirstTurnedRollsSummary = ({ total, money }: Props) => {
	return (
		<Paper elevation={1} sx={{ px: 2, py: 0.75 }}>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 4,
					flexWrap: "wrap",
				}}
			>
				<Typography variant="body2">
					<strong>Total:</strong> {total} roll{total === 1 ? "" : "s"}
				</Typography>
				{money && (
					<Typography variant="body2">
						<strong>{money.label}:</strong> {formatMoneyTotal(money.value)}
					</Typography>
				)}
			</Box>
		</Paper>
	);
};
